import { Maybe } from 'graphql/jsutils/Maybe';
import { NextRouter } from 'next/router';

import { isSportsVOD } from 'src/components/MetaButtons/WatchlistBtn/WatchlistHandler';

import { getCookie } from './browserStorageHandler';
import { globalUrlHelper } from './common';
import { DynamicObject } from './commonTypes';
import {
  ASSET_SUBTYPE,
  ASSET_TYPE,
  GENRES,
  TAGS
} from './constants/AppConstants';
import { COUNTRY, DISPLAY_LANGUAGE_COOKIE } from './constants/cookieConstants';
import {
  HamburgerMenuLinks,
  NavMenuLinks,
  PARTNER_SUBSCRIPTION
} from './constants/RouterConstants';
import {
  ConsumptionPageUrls,
  CountryCode,
  DisplayLanguage,
  LIVE_EVENT,
  MATCH_CLIPS,
  NavMenuElements,
  VIEW_ALL
} from './constants/stringConstants';
import { SPORTS_ROUTE } from './constants/utilConstants';
import { KeyValuePair } from './ConsumptionHelper/types';
import { generatePathName } from './OGTags';
import { ContentPartner } from '../services/GraphQL/Queries/types';

export const replaceWithCorrectUrl = (
  slugData: string,
  router: NextRouter,
  data: any,
  pagename: string,
  episodeData?: any
) => {
  let shouldEditUrl = false;
  let finalUrl = '';
  const routerContentId =
    pagename === NavMenuElements.MOVIES
      ? router.query.movieId
      : router.query.episodeId;
  const contentId =
    pagename === NavMenuElements.MOVIES ? data?.id : episodeData?.id;
  if (slugData !== router.asPath && contentId === routerContentId) {
    shouldEditUrl = true;
  }
  if (shouldEditUrl) {
    finalUrl = urlFormation(router.asPath, data, pagename, episodeData);
  }
  if (finalUrl && finalUrl !== router.asPath) {
    router.replace(finalUrl);
  }
};

export const checkKidsCard = (genres: KeyValuePair[]) => {
  let isKidCard = false;
  let isEduaraCard = false;
  if (genres) {
    genres.forEach((ele) => {
      const { id = '' } = ele || {};
      if (id === GENRES.KIDS || id === GENRES.KID) {
        isKidCard = true;
      } else if (id === GENRES.EDUCATION) {
        isEduaraCard = true;
      }
    });
  }
  return isKidCard && !isEduaraCard;
};

export const isSportsEvent = (path: string) =>
  path && path.includes(SPORTS_ROUTE);

export const isSportsLiveEvent = ({
  path = '',
  assetType = '',
  assetSubType = ''
}) => {
  return (
    (Number(assetType) === ASSET_TYPE.Episode && assetSubType === LIVE_EVENT) ||
    path ===
      `/${NavMenuLinks.SPORTS}/live-streaming/:showId/:channelName/:channelId`
  );
};

export const isSportsShow = ({ assetType = NaN, tags = [] }) => {
  return (
    Number(assetType) === ASSET_TYPE.TvShow &&
    tags.filter((tag) => tag === TAGS.CRICKET || tag === TAGS.ILT20).length ===
      2
  );
};

const ASSET_HANDLER: DynamicObject = {
  tvshow: {
    default: ConsumptionPageUrls.TVSHOWS_CONSUMPTION,
    kids: ConsumptionPageUrls.KIDS_CONSUMPTION_SHOWS,
    sports: `${NavMenuLinks.SPORTS}`
  },
  original: {
    default: ConsumptionPageUrls.ZEE5ORIGINALSCONSUMPTION
  },
  video: {
    default: ConsumptionPageUrls.VIDEOS_CONSUMPTION,
    kids: ConsumptionPageUrls.KIDS_CONSUMPTION_VIDEOS,
    music: ConsumptionPageUrls.MUSICVIDEOS_CONSUMPTION,
    news: ConsumptionPageUrls.NEWS_CONSUMPTION
  },
  movie: {
    default: ConsumptionPageUrls.MOVIES_CONSUMPTION,
    kids: ConsumptionPageUrls.KIDS_CONSUMPTION_MOVIES
  },
  channels: {
    default: ConsumptionPageUrls.CHANNELCONSUMPTION
  },
  live_event: {
    sports: ConsumptionPageUrls.SPORTS_CONSUMPTION
  }
};

export const getDefaultassetType = (data: DynamicObject) => {
  let defaultAssetType;
  switch (data && data?.asset_type) {
    case 0:
      defaultAssetType = ASSET_HANDLER.video;
      break;
    case 1:
    case 6:
      defaultAssetType = ASSET_HANDLER.tvshow;
      break;
    default:
  }
  return defaultAssetType;
};

export function titleGenerator(title: string) {
  let contentTitle = '';
  if (title) {
    contentTitle = title
      .trim()
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/\//g, '-')
      .replace(/---/g, '-')
      .replace(/,/g, '')
      .replace(/&/g, 'and')
      .replace(/\./g, '')
      .replace(/[`‘’~!@#$%^&*()_|+=?;:'",.<>{}[\]]/gi, '')
      .replace(/--/g, '-');
  }
  return contentTitle;
}

export const getRangbaazDubbedPageUrl = (title: string, id: string) => {
  let audioLanguage = '';
  if (id === '0-6-4z5176940') {
    audioLanguage = 'tamil';
  } else if (id === '0-6-4z5176942') {
    audioLanguage = 'telugu';
  }
  if (audioLanguage) {
    title = title.concat('-', audioLanguage);
  }
  return title;
};

const rangbaazDubbedPageIds = ['0-6-4z5176942', '0-6-4z5176940'];

// TO DO should check for other pages except movies and tv-shows
export const urlFormation = (
  pathname: string,
  data: any,
  pagename: string,
  episodeData?: any
) => {
  let finalPathname = '';
  const assetSubtype = data?.asset_subtype;
  const genresItem = data?.genres || data?.genre;
  const iskids = checkKidsCard(genresItem);
  const sportsVod = isSportsVOD({
    assetSubType: episodeData?.asset_subtype,
    assetType: episodeData?.asset_type
  });
  const sportsLive = isSportsLiveEvent({
    assetSubType: episodeData?.asset_subtype || data?.asset_subtype,
    assetType: episodeData?.asset_type || data?.asset_type
  });
  const sportsShow = isSportsShow({
    assetType: data?.asset_type,
    tags: data?.tags
  });
  const isnews =
    genresItem &&
    genresItem.find((genreItem: KeyValuePair) =>
      genreItem.id.toLowerCase().includes(ASSET_SUBTYPE.NEWS)
    );
  const ismusic =
    genresItem &&
    genresItem.find((genreItem: KeyValuePair) =>
      genreItem.id.toLowerCase().includes(ASSET_SUBTYPE.MUSIC)
    );
  let actualUrlAssetType = '';

  const assetKeytype =
    ASSET_HANDLER[assetSubtype] || getDefaultassetType(data)?.default;

  if (assetKeytype && Number(data?.asset_type) !== 9) {
    if (assetSubtype && assetSubtype.toLowerCase() === ASSET_SUBTYPE.TV_SHOW) {
      actualUrlAssetType =
        assetKeytype[
          (iskids && ASSET_SUBTYPE.KIDS) ||
            ((sportsLive || sportsVod) && ASSET_SUBTYPE.SPORTS) ||
            ASSET_SUBTYPE.DEFAULT
        ];
    } else if (assetSubtype === ASSET_SUBTYPE.VIDEO) {
      actualUrlAssetType =
        assetKeytype[
          (iskids && ASSET_SUBTYPE.KIDS) ||
            (ismusic && ASSET_SUBTYPE.MUSIC) ||
            (isnews && ASSET_SUBTYPE.NEWS) ||
            ASSET_SUBTYPE.DEFAULT
        ];
    } else if (assetSubtype === ASSET_SUBTYPE.MOVIE) {
      actualUrlAssetType =
        assetKeytype[(iskids && ASSET_SUBTYPE.KIDS) || ASSET_SUBTYPE.DEFAULT];
    } else if (assetSubtype === LIVE_EVENT) {
      actualUrlAssetType = assetKeytype.sports;
    } else {
      actualUrlAssetType = assetKeytype[ASSET_SUBTYPE.DEFAULT];
    }
  } else if (Number(data?.asset_type) === 9) {
    actualUrlAssetType = ASSET_HANDLER.channels.default;
  }

  let showNameFromApi = sportsVod ? MATCH_CLIPS : titleGenerator(data?.title);

  const episodeNameFromApi = episodeData
    ? titleGenerator(episodeData.title)
    : null;

  const showId = data?.id;
  const episodeId = episodeData && episodeData?.id;
  const contentTitle =
    titleGenerator(data?.title) || titleGenerator(data?.original_title);
  if (rangbaazDubbedPageIds.includes(showId)) {
    showNameFromApi = getRangbaazDubbedPageUrl(showNameFromApi, showId);
  }
  const getSeasonNo = pathname.split('/')[5];

  switch (pagename) {
    case NavMenuElements.TVSHOWS:
      if (episodeId && episodeNameFromApi) {
        finalPathname = sportsLive
          ? `/${actualUrlAssetType}/live-streaming/${data?.id}/${episodeNameFromApi}/${episodeId}`
          : `/${actualUrlAssetType}/${showNameFromApi}/${showId}/${episodeNameFromApi}/${episodeId}`;
      } else if (data?.asset_type === 6 && /(latest|latest1)$/.test(pathname)) {
        const isLatestOne = /latest1$/.test(pathname);
        finalPathname = `/${actualUrlAssetType}/${showNameFromApi}/${showId}/latest${
          isLatestOne ? '1' : ''
        }`;
      } else {
        finalPathname = sportsShow
          ? `/${ASSET_HANDLER.tvshow.sports}/${process.env.ILT_TOURNAMENT_ID}/${process.env.ILT_SEASON_ID}`
          : `/${actualUrlAssetType}/${showNameFromApi}/${showId}`;
      }
      break;
    case NavMenuElements.MOVIES:
      if (/(latest1)$/.test(pathname)) {
        finalPathname = `/${actualUrlAssetType}/${showNameFromApi}/${showId}/latest1`;
      } else {
        finalPathname = `/${actualUrlAssetType}/${showNameFromApi}/${showId}`;
      }
      break;
    case NavMenuElements.CHANNELS:
    case NavMenuElements.NEWS:
    case NavMenuElements.MUSIC:
    case NavMenuElements.VIDEOS:
      finalPathname = sportsLive
        ? `/${actualUrlAssetType}/${data?.tvshow}/${showNameFromApi}/${showId}`
        : `/${actualUrlAssetType}/${showNameFromApi}/${showId}`;
      break;
    case NavMenuElements.SPORTS:
      if (/(latest)$/.test(pathname)) {
        finalPathname = sportsLive
          ? `/${ASSET_HANDLER.tvshow.sports}/${MATCH_CLIPS}/${data?.tvshow}/latest`
          : `/${ASSET_HANDLER.tvshow.sports}/${process.env.ILT_TOURNAMENT_ID}/${process.env.ILT_SEASON_ID}`;
      } else {
        finalPathname = `/${actualUrlAssetType}/${data?.tvshow}/${showNameFromApi}/${showId}`;
      }
      break;
    case NavMenuElements.ZEEORIGINALS:
      if (
        data?.total_seasons &&
        data?.total_seasons > 1 &&
        getSeasonNo &&
        /season-/.test(getSeasonNo)
      ) {
        finalPathname = `/${actualUrlAssetType}/${showNameFromApi}/${showId}/${getSeasonNo}/episodes`;
      } else {
        finalPathname = `/${actualUrlAssetType}/${showNameFromApi}/${showId}/episodes`;
      }
      break;
    case VIEW_ALL:
      if (data && data?.tags) {
        if (data?.tags.includes(TAGS.MOVIES)) {
          finalPathname = `/movies/collections/${contentTitle}/${showId}`;
        } else if (data?.tags.includes(TAGS.TV_SHOWS)) {
          finalPathname = `/${process.env.TVSHOWS}/collections/${contentTitle}/${showId}`;
        } else if (data?.tags.includes(TAGS.WEBSERIES)) {
          finalPathname = `/${process.env.ZEE5ORIGINALS}/collections/${contentTitle}/${showId}`;
        } else {
          finalPathname = `/collections/${contentTitle}/${showId}`;
        }
      }
      break;
    default:
  }

  const displayLanguage =
    getCookie(DISPLAY_LANGUAGE_COOKIE) || DisplayLanguage.ENGLISH;
  const countryCode = getCookie(COUNTRY) || CountryCode.IN;
  finalPathname = generatePathName({
    countryCode,
    translation: displayLanguage,
    url: finalPathname
  });

  return finalPathname;
};

export const validateRouteParams = (param: string): string => {
  const regex = new RegExp(/[\w-]+$/);
  return regex.test(param) ? param : '';
};

export const getAggregatorSubscriptionUrl = (
  isPremiumUser: boolean,
  isUserSubscribedToPartner: boolean,
  contentPartnerDetails: Maybe<ContentPartner> | undefined
) => {
  const pathName =
    isPremiumUser && !isUserSubscribedToPartner && contentPartnerDetails
      ? `${PARTNER_SUBSCRIPTION}/${titleGenerator(
          contentPartnerDetails?.name || ''
        )}/${contentPartnerDetails?.id}`
      : HamburgerMenuLinks.BUY_PLAN;
  return globalUrlHelper(pathName);
};
